export default {"src":"/_next/static/media/instagram.ecd5a25c.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};